import { render, staticRenderFns } from "./TemplateSummaryPopover.vue?vue&type=template&id=3eba3763"
import script from "./TemplateSummaryPopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateSummaryPopover.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports